module.exports = __webpack_public_path__ + "img/completedacourse_ILT_white.1cb88cf5.svg";